var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingConfigurationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 12.14C22.4996 10.614 21.5111 9.26385 20.0564 8.80301C20.7609 7.44824 20.5057 5.79313 19.426 4.71338C18.3463 3.63364 16.6911 3.37852 15.3364 4.08301C14.876 2.62777 13.5257 1.63867 11.9994 1.63867C10.4731 1.63867 9.12275 2.62777 8.66238 4.08301C7.30762 3.37852 5.6525 3.63364 4.57276 4.71338C3.49302 5.79313 3.2379 7.44824 3.94238 8.80301C2.48714 9.26337 1.49805 10.6137 1.49805 12.14C1.49805 13.6663 2.48714 15.0166 3.94238 15.477C3.2379 16.8318 3.49302 18.4869 4.57276 19.5666C5.6525 20.6464 7.30762 20.9015 8.66238 20.197C9.12275 21.6522 10.4731 22.6413 11.9994 22.6413C13.5257 22.6413 14.876 21.6522 15.3364 20.197C16.6911 20.9015 18.3463 20.6464 19.426 19.5666C20.5057 18.4869 20.7609 16.8318 20.0564 15.477C21.5111 15.0162 22.4996 13.666 22.4994 12.14V12.14Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 7.64004H10.7884C10.3031 7.6013 9.8252 7.7773 9.48094 8.12156C9.13667 8.46582 8.96067 8.94373 8.99942 9.42904C8.99942 11.39 14.9994 12.89 14.9994 14.851C15.0082 15.3282 14.8225 15.7883 14.4851 16.1257C14.1477 16.4632 13.6875 16.6488 13.2104 16.64H8.99942",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.64062V5.39062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8906V16.6406",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingConfigurationIcon);
export default __webpack_public_path__ + "static/media/pricing-configuration-icon.7cd952d07a9b25b1d2df95fe48db29c8.svg";
export { ForwardRef as ReactComponent };